import React from "react"
import { Box } from "@mui/material"

import useOuterLengthsConfiguration from "@secureo/common/hooks/cylinderConfigurations/useOuterLengthsConfiguration"
import { TextField, MenuItem } from "@mui/material"
import { GridTemplateRowName } from "../LockingSystemMatrix"
import LockingSystemItemWrapper from "../LockingSystemItemWrapper"
import StyledLockingSystemCell from "../StyledLockingSystemCell"

const OuterLengthConfiguration = ({
	isLoading,
	uuid,
	gridRowName,
	outerLengths,
	selectedOuterLength,
	setSelectedOuterLength,
}: Props) => {
	const onOuterLengthChange = (selectedOuterLength: number) => {
		setSelectedOuterLength(uuid, selectedOuterLength)
	}

	const { outerLengthInputProps, availableOuterLengths } = useOuterLengthsConfiguration(
		outerLengths,
		selectedOuterLength,
		onOuterLengthChange,
	)

	return (
		<>
			<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName="outerLength">
				<LockingSystemItemWrapper>
					<TextField
						id="outerLength"
						label="A"
						{...outerLengthInputProps}
						margin="normal"
						variant="filled"
						select
						fullWidth
						disabled={isLoading || !setSelectedOuterLength}
						style={{ marginTop: 0 }}
					>
						{availableOuterLengths.map((outerLength) => (
							<MenuItem key={outerLength} value={outerLength}>
								{outerLength} mm
							</MenuItem>
						))}
					</TextField>
				</LockingSystemItemWrapper>
			</StyledLockingSystemCell>
			<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName="innerLength">
				<LockingSystemItemWrapper>
					<Box mt={2} style={{ textAlign: "center" }}>
						-
					</Box>
				</LockingSystemItemWrapper>
			</StyledLockingSystemCell>
		</>
	)
}

interface Props {
	isLoading: boolean
	uuid: string
	gridRowName: GridTemplateRowName
	outerLengths: number[]
	selectedOuterLength: number
	setSelectedOuterLength?: (uuid: string, selectedOuterLength: number) => void
}

export default OuterLengthConfiguration
